import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_ALLERGEN,
  SET_ALLERGEN_PAGE_TO_DIRTY,
  UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS,
  UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS,
  UPDATE_ALLERGEN_IMAGE_DETAILS,
  UPDATE_ALLERGEN_SIMPLE_DETAILS,
} from '../action-types'
import { ALLERGEN_INITIAL_STATE } from '../initial-states'

const allergenReducer = (state = ALLERGEN_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ALLERGEN_PAGE_TO_DIRTY:
      return produce(state, nextState => assign(nextState, action.payload))
    case FETCH_ALLERGEN.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_ALLERGEN.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.allergen,
        }),
      )

    case FETCH_ALLERGEN.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_ALLERGEN.CLEANUP:
      return { ...ALLERGEN_INITIAL_STATE }

    case UPDATE_ALLERGEN_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_ALLERGEN_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateAllergenSimpleDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_ALLERGEN_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_ALLERGEN_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_ALLERGEN_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateAllergenImageDetails,
          ),
        }),
      )

    case UPDATE_ALLERGEN_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedAllergensDetailsLoading: true,
          includedAllergensDetailsError: undefined,
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedAllergensDetailsLoading: false,
          includedAllergensDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateAllergenIncludedAllergensDetails,
          ),
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedAllergensDetailsLoading: false,
          includedAllergensDetailsError: action.error.message,
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedIngredientsDetailsLoading: true,
          includedIngredientsDetailsError: undefined,
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedIngredientsDetailsLoading: false,
          includedIngredientsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateAllergenIncludedIngredientsDetails,
          ),
        }),
      )

    case UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isIncludedIngredientsDetailsLoading: false,
          includedIngredientsDetailsError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default allergenReducer
